import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {googleOverview_template} from "../components/templates/googleOverview_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class googleOverview extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected googleOverview_template: googleOverview_template;
    protected firstLoad = true;

    protected getModuleName(){
        return "googleOverview";
    }

    buildContent() : Array<Element>{

        this.googleOverview_template = new googleOverview_template( "googleOverview", this.viewModel, this );
        this.template = this.googleOverview_template;

        return [this.googleOverview_template.build()];
    }

    public fillPage() : void{

        this.googleOverview_template.buildDatePickerCalendar();
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api//googleOverview/list_form_data/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.googleOverview_template.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();

                if (responseParsed.hasGoogleOverviewReportReadPermission){

                    obj.getListData();
                }
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.googleOverview_template.builtTemplate);
            }
        };
    }

    public getListData(): void{

        this.loadingIn(this.googleOverview_template.builtTemplate.children.namedItem("list-results"));
        this.googleOverview_template.getTemplateViewModel().isChartLoading(1);

        let subViewModel = this.template.getViewModelForRequest();
        let baseApiUrl = '/api/googleOverview/list_data';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.googleOverview_template.resetSelectedRows();
                obj.googleOverview_template.validationsList.clearMessages();
                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.googleOverview_template.getTemplateViewModel().isChartLoading(0);
                obj.loadingOut(obj.googleOverview_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }


    protected updateFilters(responseParsed: any) {

        this.googleOverview_template.setBrandsFilterItems(responseParsed.departments);
        this.googleOverview_template.setSourcesFilterItems(responseParsed.sources);
        this.googleOverview_template.setViewModesItems();
        this.googleOverview_template.setViewMethodsItems();
        this.googleOverview_template.setDateLevelsItems();
        this.googleOverview_template.setDefaultDates(responseParsed.maxSearchConsoleDate);
        this.googleOverview_template.setHasGoogleOverviewReportReadPermission(responseParsed.hasGoogleOverviewReportReadPermission);

        // Default selection on first load.
        this.googleOverview_template.filterSources.getTemplateViewModel().selectedItems(["search"]);

        // Collider, CBR and ScreenRant
        this.googleOverview_template.filterBrands.setSelectedItems([{id: '22'}, {id: '5'}, {id: '6'}]);
    }

    protected updateList(responseParsed: any) {

        this.googleOverview_template.resetData();

        if (this.googleOverview_template.getTemplateViewModel().viewModeSelected() == "trends"){

            if (this.firstLoad){

                // Needed to display the selected brands and sources on first load.
                this.googleOverview_template.filterSources.setTags(this.googleOverview_template.filterSources.getSelectedItems(), this.googleOverview_template.filterSources.getItems());
                this.googleOverview_template.filterBrands.setTags(this.googleOverview_template.filterBrands.getSelectedItems(), this.googleOverview_template.filterBrands.getItems());
            }

            this.googleOverview_template.updateTrendsGraphData(responseParsed.graphLinesInfo, responseParsed.data);

        }else if (this.googleOverview_template.getTemplateViewModel().viewModeSelected() == "comparison") {

            if (this.googleOverview_template.getTemplateViewModel().viewMethodSelected() == 'periods'){

                this.googleOverview_template.updateComparisonPeriodGraphData(responseParsed.data);
            } else{

                // Aggregated view method
                this.googleOverview_template.updateComparisonAggregatedGraphData(responseParsed.data);
            }
        }else {

            this.googleOverview_template.setHeader(responseParsed.headers);
            this.googleOverview_template.setTableData(responseParsed.data);
        }

        this.firstLoad = false;
    }

    protected filterSingleDateOnChange() {

        this.getListData();
    }

    protected filterMultipleSelectorOnChange() {

        this.getListData();
    }

    protected filterDateOnChange() {

        this.getListData();
    }

    protected filterSimpleOnChange() {

        this.getListData();
    }

    public filterDropdownOnChange(){

        this.getListData();
    }
}



// WEBPACK FOOTER //
// ./js/modules/googleOverview.ts